import React from 'react'
import '../../styles/about.css'
import { useSelector } from 'react-redux';
import { PageLine, PageHeading, Education, Button } from '../../componetns';
import aboutBanner from '../../images/about-banner.png';
import { Link } from 'react-scroll';
import AOS from 'aos';
import 'aos/dist/aos.css';
const About = () => {
    AOS.init();
    const { isDark } = useSelector((state) => state.useReducer);
    return (
        <div className='about-main' style={{ backgroundColor: `${isDark ? "#070F2B" : "#fff"}` }} name="about">
            <PageLine />
            <PageHeading heading="About Me" />
            <div className='container' >
                <div className='row'>
                    <div className='col-12 col-md-6 about-me-data' >
                        <h1 style={{ color: "#3F51B5" }} data-aos="zoom-in">Front-End Web Developer & WordPress Specialist</h1>
                        <p style={{ color: `${isDark ? "#fff" : "#000"}` }}>I am a passionate Front-End Web Developer with experience in creating
                            visually appealing and fully responsive websites. I specialize in
                            turning ideas into functional digital products using modern web
                            technologies.

                            I also work as a WordPress developer, building business websites,
                            portfolios, and booking systems with a strong focus on performance,
                            SEO, and user experience. I enjoy writing clean code and delivering
                            solutions that meet real-world business needs.
                        </p>
                        <h1 style={{ color: "#3F51B5" }}>skills</h1>
                        <p style={{ color: `${isDark ? "#fff" : "#000"}` }}>I work with modern web technologies to build fast, scalable, and user-focused web applications.</p>
                        <span style={{ color: `${isDark ? "#fff" : "#000"}` }}>html</span>
                        <span style={{ color: `${isDark ? "#fff" : "#000"}` }}>css</span>
                        <span style={{ color: `${isDark ? "#fff" : "#000"}` }}>javaScript</span>
                        <span style={{ color: `${isDark ? "#fff" : "#000"}` }}>bootstrap</span>
                        <span style={{ color: `${isDark ? "#fff" : "#000"}` }}>WordPress</span>
                        <span style={{ color: `${isDark ? "#fff" : "#000"}` }}>Elementor</span>
                        <Link to="contact" spy={true}
                            smooth={true}
                            offset={-100}
                            duration={500}><Button title="Contact Me" /></Link>
                    </div>
                    <div className='col-12 col-md-6 about-banner'>
                        <img src={aboutBanner} alt='about' data-aos="zoom-in" />
                    </div>
                </div>
            </div>
            <Education />
        </div>
    )
}

export default About
